import AnimateOnClick from "@common/animations/AnimateOnClick";
import { Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import React from "react";

const LinkElement = ({ title, link, image_url }) => {
  return (
    <AnimateOnClick whileHover={{ scale: 1.03 }}>
      <Stack
        direction="row"
        gap={1}
        sx={(theme) => ({
          display: "flex",
          width: "100%",
          backgroundColor: theme.palette.secondary.light,
          color: theme.palette.secondary.contrastText,
          borderRadius: 2,
          height: {
            xs: image_url && 80,
            sm: image_url && 120,
          },
          textDecoration: "none",
          boxShadow: 1,
          my: 2,
          "&:hover": {
            cursor: "pointer",
            backgroundColor: theme.palette.secondary.main,
          },
        })}
        component="a"
        href={link}
        target="_blank"
        rel="noreferrer"
        justifyContent="center"
        alignItems="center"
      >
        {image_url && (
          <Box
            component="img"
            src={image_url}
            alt={title}
            sx={{
              height: "120%",
              aspectRatio: "1/1",
              borderRadius: 4,
              overflow: "hidden",
              objectFit: "cover",
            }}
          />
        )}
        <Typography
          sx={{ flex: 1, fontWeight: 500, wordBreak: "break-word", p: 1 }}
          textAlign="center"
        >
          {title}
        </Typography>
      </Stack>
    </AnimateOnClick>
  );
};

export default LinkElement;
